import React, {FC} from 'react'
import { Segment } from 'semantic-ui-react'
import { CustomFieldsGroup, CustomFieldsSubGroup } from '@lk/api'

//@ts-ignore
import { Container, SegmentGroup } from 'shared/StyledComponents'

import { translateBase, icon } from '../helpers'
import DynamicFields from '../../DynamicFields'
import { CustomFieldsPropTypes } from '../types'

function getFormName(props: CustomFieldsPropTypes) {
  return `client-${props.data.base.ID}-customfields`
}

function getClientTypeConstant(props: CustomFieldsPropTypes) {
  const { ClientTypeID } = props.data.base

  switch (ClientTypeID) {
    case 1:
      return CustomFieldsSubGroup.ClientPhysical

    case 3:
      return CustomFieldsSubGroup.ClientJuridical

    default:
      return CustomFieldsSubGroup.ClientGroup
  }
}

const CustomFields:FC<CustomFieldsPropTypes> = (props) => {
  const {
    data: { custfields, base },
  } = props

  return (
    <Container>
      <SegmentGroup>
        <Segment.Group>
          <DynamicFields
            type={CustomFieldsGroup.Client}
            subType={getClientTypeConstant(props)}
            initialValues={custfields}
            form={getFormName(props)}
            clientType={base.ClientTypeID}
          />
        </Segment.Group>
      </SegmentGroup>
    </Container>
  )
}


CustomFields.defaultProps = {
  //@ts-ignore
  data: {},
}

//@ts-ignore
CustomFields.config = {
  title: () => translateBase('tb_custfields'),
  name: 'custfields ',
  component: CustomFields,
  api: ['base', 'custfields'],
  icon: icon('tb_custfields'),
}

export default CustomFields
